import { MultiValuedListItem } from '../../MultiValuedList'
import { FileMultiValue } from '../FileMultiValue'

function FileMultiValuedListItem({
  additionalTooltipInfo,
  item,
  showTooltip,
  variant,
  onClick,
  ...itemProps
}) {
  return (
    <MultiValuedListItem {...itemProps} variant={variant}>
      <FileMultiValue
        additionalTooltipInfo={additionalTooltipInfo}
        item={item}
        showTooltip={showTooltip}
        onClick={onClick}
      />
    </MultiValuedListItem>
  )
}

export default FileMultiValuedListItem
